/**
 * 常量
 */
import { deepFreeze } from '@/utils/objUtil'
import MyEnum from '@/common/MyEnum'
import { enumValue } from '@/common/EnumValue'
const freeze = Object.freeze

export const RESP_CODE = freeze({
  SUCCESS: 200
})

export const STATUS_CODE = freeze({
  SUCCESS: 0
})

export class WarnError extends Error {
  type = 'warn'
}

export const SBCcaseList = [
  '！',
  '“',
  '”',
  '’',
  '（',
  '）',
  '，',
  '—',
  '。',
  '：',
  '；',
  '？',
  '【',
  '】',
  '《',
  '》',
  '＾',
  '～',
  '　'
]

export const licenseFileType = freeze(['jpg', 'jpeg', 'png', 'pdf', 'msg', 'xls', 'xlsx', 'doc', 'docx', 'rar', 'zip'])
export const trackType = freeze(['mp3', 'flac', 'ogg', 'wav', 'ape', 'wma'])
export const imageType = freeze(['jpg', 'jpeg', 'png'])
export const lyricType = freeze(['txt', 'lrc', 'trc', 'qrc'])
export const videoType = freeze(['mp4', '3gp', 'avi', 'mkv', 'wmv', 'mpg', 'vob', 'flv', 'swf', 'mov', 'webm', 'ocg', 'dat', 'm4v'])

export class UserLevel extends MyEnum {
  static INIT = enumValue(1, '未注册')
  static REGISTERING = enumValue(2, '注册中') // 前端自用
  static REGISTERED = enumValue(10, '未审核')
  static REJECT = enumValue(19, '审核不通过')
  static PASS = enumValue(20, '审核通过')
}

export class CP_TYPE extends MyEnum {
  static COP = enumValue(1, '合作公司')
  static FREE = enumValue(2, '免费授权')
  static GOOD_B = enumValue(3, '优选内容B')
  static GOOD_A = enumValue(4, '优选内容A')
  static GOOD_C = enumValue(5, '优选内容C')
}

export const switchMap = freeze({
  0: '否',
  1: '是',
})

export const statusIconMap = freeze({
  1: 'wait',
  2: 'offline',
  3: 'check',
  4: 'reject',
  5: 'online'
})

export const conditionMap = freeze({
  1: '待上架',
  2: '已下架',
  3: '审核中',
  4: '不通过',
  5: '已上架'
})

export const checkConditionOption = freeze([[[3, 4], '全部'], [[3], '审核中'], [[4], '不通过']])

export const authProductMap = freeze({
  1: 'QQ音乐',
  2: '全民K歌',
  3: '酷狗',
  4: '酷我',
  5: '爱听卓乐',
  6: '企鹅FM',
  7: '微视',
  8: '轻听',
  9: '微信',
  10: 'QQ空间',
  11: '腾讯视频',
  12: '繁星（酷狗）直播',
  13: '聚星（酷我）直播',
  14: '酷我K歌',
  16: '5SING',
  17: '酷FM',
  18: '游戏产品',
})

export const copyrightAreaMap = freeze({
  0: '中国大陆',
  1: '中国香港',
  2: '中国台湾',
  3: '中国澳门',
  4: '马来西亚',
  5: '泰国',
  6: '印尼',
  7: '亚洲地区',
  8: '全世界',
  9: '南非',
  10: '缅甸',
  11: '菲律宾',
  12: '印度',
  13: '新加坡',
  14: '越南',
  15: '文莱',
  16: '俄罗斯',
  17: '美国',
  18: '加拿大'
})

export const languageMap = freeze({
  0: '普通话',
  1: '粤语',
  2: '闽南语',
  3: '日语',
  4: '韩语',
  5: '英语',
  6: '法语',
  7: '其他',
  8: '拉丁',
  9: '纯音乐',
  10: '德语',
  11: '俄语',
  12: '印度语',
  13: '泰语',
  14: '印尼语',
  15: '菲律宾语',
  16: '西班牙语',
  17: '印第安语',
  18: '葡萄牙语',
  19: '意大利语',
  20: '瑞典语',
  21: '波兰语',
  22: '丹麦语',
  23: '芬兰语',
  24: '越南语',
  25: '藏语',
  26: '马来语',
  27: '阿拉伯语',
  28: '客家语',
  29: '潮汕语',
  30: '维语',
  31: '冰岛语',
  32: '挪威语',
  33: '希腊语',
  34: '荷兰语',
  35: '捷克语',
  36: '乌克兰语',
  37: '蒙语',
  38: '哈萨克语',
  39: '缅甸语',
  40: '格鲁吉亚语',
  41: '罗马尼亚语',
  '-1': '未知',
})

export const statusMap = freeze({
  0: '隐藏',
  1: '上架',
  2: '停用'
})

// 1. 设置顺序, 2 调整传递参数
export const storedStatusOption = [[[0, 1], '全部'], [[1], '上架'], [[0], '隐藏']]

export const versionMap = freeze({
  '-1': '未知',
  0: '完整版',
  1: 'Radio Edit',
  // 2: '清晰版',
  3: 'Live',
  4: 'TV Version',
  5: 'Demo',
  6: 'Remix',
  // 7: 'DJ长音频',
  8: '伴奏',
  9: '语言版',
  10: 'LP版',
  11: 'Acoustic',
  12: 'Remaster',
  13: 'Revival',
  14: 'Clean',
  15: 'Explicit',
  16: 'Performance',
  17: 'Reprise',
  18: 'Jam Version',
  19: '纯音乐',
  20: 'Cast Version',
  21: 'Unplugged',
  22: '口白',
  23: 'Extended Version',
  // 24: '铃声',
  // 25: '恶搞版',
  26: 'MR',
  // 27: '试听版',
  28: 'DJ版',
  29: 'Acappella',
  // 30: 'Arr',
  // 31: 'Performod',
  // 32: 'UK Version',
  // 33: 'Ao Vivo',
  34: '翻唱版',
  35: 'Bonus Track',
  36: 'Orchestra',
  37: 'Album Version',
  38: 'Single Version',
  39: 'Rerecorded',
  40: '翻奏版',
  41: '地区版',
  42: '串烧',
})

export const areaList = deepFreeze([

  {
    id: 0,
    name: '港台',
    disabled: false
  },
  {
    id: 1,
    name: '内地',
    disabled: false
  },
  {
    id: 2,
    name: '日韩',
    disabled: false
  },
  {
    id: 3,
    name: '欧美',
    disabled: false
  },
  {
    id: 4,
    name: '其他',
    disabled: false
  },
  {
    id: 5,
    name: '东南亚',
    disabled: false
  },
  {
    id: 6,
    name: '未知',
    disabled: false
  }
])

export const areaMap = areaList.reduce((result, item) => {
  result[item.id] = item.name

  return result
}, {})

export const canAuthMap = {
  0: '否',
  1: '是',
}

export const canLegalRightsMap = {
  0: '否',
  1: '是',
}

export const isAgentMap = freeze({
  0: '自有',
  1: '代理'
})

export const isOnlyMap = freeze({
  0: '非总代理',
  1: '总代理',
})

export const cpStatusMap = freeze({
  '-1': '确认无版权',
  1: '有版权',
  0: '无版权'
})

export const cpDefectMap = {
  0: '无',
  1: '盗歌',
  2: '抄袭',
  3: '翻唱',
  4: '版权重叠',
  5: '无版权证明',
  6: '重复片段'
}

export const hiddenReasonMap = {
  0: '无',
  1: '无媒体文件',
  2: '重复上传',
  3: '音频异常',
  4: '网易总代理',
  5: '阿里总代理',
  6: '百度总代理',
  7: '普通无版权',
  8: '严重无版权',
  10: '文化部通报',
  11: '涉黄赌毒敏感',
  12: '待上线',
  13: '非正式',
  15: '其他',
  16: '版权到期',
  17: '版权到期(重点)',
  18: '版权诉讼'
}

export const hiddenReasonToOuterMap = freeze({
  1: '质量瑕疵',
  2: '质量瑕疵',
  3: '质量瑕疵',

  4: '版权问题',
  5: '版权问题',
  6: '版权问题',
  7: '版权问题',
  8: '版权问题',
  9: '版权问题',
  20: '版权问题',
  16: '版权问题',
  17: '版权问题',
  18: '版权问题',

  10: '涉及黄色、暴力、恐怖等信息',
  11: '涉及黄色、暴力、恐怖等信息',
  19: '涉及黄色、暴力、恐怖等信息',
  23: '涉及黄色、暴力、恐怖等信息',
  24: '涉及黄色、暴力、恐怖等信息',

  12: '歌曲待上线',
  25: '歌曲待上线',

  13: '其他原因',
  14: '其他原因',
  15: '其他原因',
  21: '其他原因',
  22: '其他原因',

})

export const hiddenReasonToOuterOption = freeze(
  Object.entries(hiddenReasonToOuterMap).reduce((res, [key, text]) => {
    (res[text] || (res[text] = [])).push(+key)
    return res
  }, {})
)

// 平台上架状态
export const platformMap = freeze({
  qq: 'QQ音乐',
  kg: '酷狗',
  kw: '酷我',
  // um: 'Q爱听'
})

export const platformStatusMap = freeze({
  1: '已上架',
  0: '未上架'
})

export const statusIconConfigList = [
  {
    value: 1,
    icon: {
      1: 'wait-angle',
      2: 'wait'
    },
    label: '待上架'
  },
  {
    value: 2,
    icon: {
      1: 'offline-angle',
      2: 'offline'
    },
    label: '已下架'
  },
  {
    value: 3,
    icon: {
      1: 'check-angle',
      2: 'check'
    },
    label: '审核中'
  },
  {
    value: 4,
    icon: {
      1: 'reject-angle',
      2: 'reject'
    },
    label: '不通过'
  },
  {
    value: 5,
    icon: {
      1: 'online-angle',
      2: 'online'
    },
    label: '已上架'
  }
]

export const statusIconConfigMap = {
  1: {
    value: 1,
    icon: {
      1: 'wait-angle',
      2: 'wait'
    },
    label: '待上架'
  },
  2: {
    value: 2,
    icon: {
      1: 'offline-angle',
      2: 'offline'
    },
    label: '已下架'
  },
  3: {
    value: 3,
    icon: {
      1: 'check-angle',
      2: 'check'
    },
    label: '审核中'
  },
  4: {
    value: 4,
    icon: {
      1: 'reject-angle',
      2: 'reject'
    },
    label: '不通过'
  },
  5: {
    value: 5,
    icon: {
      1: 'online-angle',
      2: 'online'
    },
    label: '已上架'
  }
}

export const audioCheckErrorMap = freeze({
  3: '无法识别的wav',
  4: '后缀名出错',
  6: '声道不符合标准',
  7: '采样率不符合标准',
  '-1': '空指针',
  '-2': '无效参数',
  '-3': '内存申请失败',
  '-4': '文件打开错误',
  '-5': '数据长度过短（小于3s）',
  '-6': '数据越界',
  '-8': '库加载错误',
  '-7': '音频类型错误',
  '-9': '解码出错',
  '-10': '文件不存在',
  '-11': '文件过大',
  '-12': '文件截断',
  '-13': '无效文件后缀',
  '-14': '无效规则参数',
  '-100': '未知错误 ',
})
export const audioCheckMediumMap = freeze({
  2: '格式白噪声',
  8: '量化位数不符合标准',
  9: '码率不符合标准',
  11: '长溢出/长破音',
  12: '假双声道',
  26: '咔嚓声/啪声',
  27: '开头咔嚓声/啪声',
  28: '长空白音',
  29: '突发噪声 ',
  30: '高解析音频 ',
})
export const audioCheckLowMap = freeze({
  16: '音量过小',
  17: '音量正常',
  18: '音量过大',
  19: '假无损',
  20: '假320比特率',
  24: '低品质',
  25: '断点',
  10: '时长不符合标准',
  15: '假5.1声道',
  13: '声道反相',
})
export const trackAudioCheckMap = freeze({
  0: '正常',

  // 严重
  ...audioCheckErrorMap,

  // 中等问题
  ...audioCheckMediumMap,

  // 一般问题
  ...audioCheckLowMap
})

export const genreMap = freeze({
  1: '宗教/Religious Music',
  2: '流行/Pop',
  3: '爵士/Jazz',
  4: '嘻哈/Rap',
  5: '民谣/Folk',
  6: '乡村/Country',
  7: '蓝调/Blues',
  8: '节奏布鲁斯/R&B',
  9: '摇滚/Rock',
  10: '新世纪/New Age',
  11: '金属/Metal',
  12: '雷鬼/Reggae',
  13: '电子舞曲/EDM',
  14: '古典/Classical',
  15: '轻音乐/Easy Listening',
  16: '儿童/Children\'s Music',
  17: '中国特色/Chinese characteristics',
  18: '世界音乐/World Music',
  19: '原声/Soundtrack',
  20: '实验音乐/Experimental',
  21: '有声内容/Spoken Word',
  22: '其他/Other',
  23: '中国风/China Wave',
  24: '古风/Chinese Antiquity',
  25: 'DJ土嗨/DJ',
  26: '喊麦/Loud Microphone Controller',
  27: '节日音乐/Holiday',
  28: 'AI生成内容'
})

export const subGenreMap = freeze({

  101: '佛教音乐/Buddhist music',
  102: '基督教音乐/Christian music',
  103: '当代基督/CCM / Contemporary Christian Music',
  104: '中国道教音乐/Chinese Taoist Music',

  201: '中文流行/C-Pop',
  202: '粤语流行/Cantonese Pop',
  203: '日本流行/J-Pop',
  204: '韩国流行/K-Pop',
  205: '成人时代/Adult Contemporary',
  206: '独立流行/Indie Pop',
  207: '青少年流行/Teen Pop',
  208: '传统流行/Traditional Pop',
  209: '非洲流行/Afropop',
  210: '阿拉伯流行/Arab Pop',
  211: '印度流行/Indian Popp',
  212: '俄罗斯流行/Russian Pop',
  213: '土耳其流行/Turkish Pop',
  214: '广播流行曲/AM Pop',
  215: '巴洛克流行/Baroque Pop',
  216: '布瑞尔大厦流行/Brill Building Pop',
  217: '泡泡糖流行/Bubblegum',
  218: '名人现象/Celebrity',
  219: '当代流行/摇滚/Contemporary Pop / Rock',
  220: '偶像流行/Pop Idol',
  221: '社交媒体流行/Social Media Pop',
  222: '电音流行/Electropop',
  223: '欧美流行/Western Pop',
  224: '流行舞曲/Dance Pop',
  225: '梦幻流行/Dream Pop',
  226: '网络流行/Cyber Hit',
  227: '男孩团体/Boy Band',
  228: '女子团体/Girl Group',
  229: '迷幻流行/Psychedelic Pop',
  230: '氛围流行/Ambient Pop',
  231: '阳光流行/Sunshine Pop',
  232: '无伴奏合唱/A cappella',
  233: '韩国抒情歌曲/Korean Ballad',
  234: '噪音流行/Noise Pop',
  235: '都市流行/City Pop',
  236: '噪响流行/Jangle Pop',
  237: '前卫流行/Progressive Pop',
  238: '艺术流行/Art Pop',
  239: '童稚流行/Twee Pop',
  240: '闽南语流行/Bân lâm gú Pop',
  241: '室内流行/Chamber Pop',
  242: '文雅流行/Sophisti Pop',
  243: '凯尔特流行/Celtic Pop',
  244: '致幻流行/Hypnagogic Pop',
  245: '法国流行/French Pop',
  246: '德国流行/German Pop',
  247: '意大利流行/Italian Pop',
  248: '弗拉明戈流行/Flamenco Pop',
  249: '夏威夷流行/Hawaiian Pop',
  250: '荷兰流行/Dutch Pop',
  251: '拉丁流行/Latin Pop',
  252: '复古流行/Retro Pop',

  301: '巴萨诺瓦/Bossa Nova',
  302: '波普/Bop',
  303: '大乐团/Big Band',
  304: '当代爵士/Contemporary Jazz',
  305: '迪克西兰爵士/Dixieland',
  306: '第三潮流/Third Stream',
  307: '电爵士/Nu Jazz',
  308: '非洲古巴爵士/Afro Cuban Jazz',
  309: '非洲爵士/African Jazz',
  310: '后波普/Post Bop',
  311: '吉普赛爵士/Gypsy Jazz',
  312: '爵士放克/Jazz Funk',
  313: '爵士流行/Jazz Pop',
  314: '拉格泰姆/Ragtime',
  315: '冷爵士/Cool Jazz',
  316: '灵魂爵士/Soul Jazz',
  317: '人声爵士/Vocal Jazz',
  318: '融合爵士/Jazz Fusion',
  319: '柔顺爵士/Smooth Jazz',
  320: '实验大乐队/Experimental Big Band',
  321: '室内爵士/Chamber Jazz',
  322: '酸性爵士/Acid Jazz',
  323: '调式爵士/Modal Jazz',
  324: '先锋爵士/Avant Garde Jazz',
  325: '新奥尔良爵士/New Orleans Jazz',
  326: '摇摆乐/Swing',
  327: '硬波普/Hard Bop',
  328: '噪音爵士/Skiffle',
  329: '主流爵士/Mainstream Jazz',
  330: '自由爵士/Free Jazz',
  331: '舞池爵士/Ballroom Dance',
  332: '布吉乌吉爵士/Boogie Woogie',
  333: '巴西爵士/Brazilian Jazz',
  334: '英伦歌舞团/British Dance Bands',
  335: '芝加哥爵士/Chicago Jazz',
  336: '欧洲大陆爵士/Continental Jazz',
  337: '跨界爵士/Crossover Jazz',
  338: '古巴爵士/Cuban Jazz',
  339: '歌舞团/Dance Bands',
  340: '早期创新爵士/Early Creative',
  341: '早期爵士/Early Jazz',
  342: '电音爵士/Electric Jazz',
  343: '融合/Fusion',
  344: '吉他爵士/Guitar Jazz',
  345: '热爵士/Hot Jazz',
  346: '牛仔爵士/Jive',
  347: '拉丁爵士/Latin Jazz',
  348: '切磋爵士/M Base',
  349: '莫达尔爵士/Modal Music',
  350: '现代大乐团/Modern Big Band',
  351: '现代创新爵士/Modern Creative',
  352: '现代自由爵士/Modern Free',
  353: '现代爵士/Modern Jazz',
  354: '新波普爵士/Neo Bop',
  355: '新奥尔良铜管乐团/New Orleans Brass Bands',
  356: '独特拉格泰姆爵士/Novelty Ragtime',
  357: '管弦爵士/Orchestral Jazz',
  358: '钢琴爵士/Piano Jazz',
  359: '前卫大乐团/Progressive Big Band',
  360: '前卫爵士/Progressive Jazz',
  361: '萨克斯爵士/Saxophone Jazz',
  362: '社团歌舞团/Society Dance Band',
  363: '标准爵士/Standards',
  364: '跨步爵士/Stride',
  365: '甜性爵士/Sweet Bands',
  366: '传统爵士/Trad Jazz',
  367: '长号爵士/Trombone Jazz',
  368: '小号爵士/Trumpet Jazz',
  369: '电颤琴/马林巴爵士/Vibraphone / Marimba Jazz',
  370: '西岸爵士/West Coast Jazz',

  401: '德语说唱/German Rap',
  402: '实验性说唱/Left Field Hip Hop',
  403: '政治说唱/Political Rap',
  404: '唱盘主义说唱/Turntablism',
  405: '粗口说唱/Dirty Rap',
  406: '黄金时代说唱/Golden Age',
  407: '低音音乐说唱/Bass Music',
  408: '当代说唱/Contemporary Rap',
  409: '乡村说唱/Country Rap',
  410: '南部说唱/Dirty South',
  411: '帮派放克说唱/G Funk',
  412: '帮派说唱/Gangsta Rap',
  413: '恐怖说唱/Horror Rap',
  414: '派对说唱/Party Rap',
  415: '流行说唱/Pop Rap',
  416: '陷阱说唱/Trap Rap',
  417: '硬核说唱/Hardcore Hip Hop',
  418: '西岸说唱/West Coast Hip Hop',
  419: '东岸说唱/East Coast Hip Hop',
  420: '老派说唱/Old school Hip Hop',
  421: '爵士嘻哈/Jazz Hip Hop',
  422: '南方说唱/Southern Hip Hop',
  423: '中西部说唱/Midwest Hip Hop',
  424: '英伦说唱/British Hip Hop',
  425: '喜剧说唱/Comedy Hip Hop',
  426: '地下说唱/Underground Hip Hop',
  427: '中国地下说唱/Chinese Underground Hip Hop',
  428: '意识说唱/Conscious Hip Hop',
  429: '另类说唱/Alternative Hip Hop',
  430: '实验说唱/Experimental Hip Hop',
  431: '法国说唱/French Hip Hop',
  432: '基督教说唱/Christian Hip Hop',
  433: '说唱浩室/Hip House',
  434: '器乐说唱/Instrumental Hip Hop',
  435: '云雾说唱/Cloud Rap',
  436: '拉丁说唱/Latin Rap',

  501: '当代民谣/Contemporary Folk',
  502: '独立民谣/Indie Folk',
  503: '城市民谣/Urban Folk',
  504: '民谣流行/Folk Pop',
  505: '校园民谣/Campus Folk',
  506: '传统民谣/Traditional Folk',
  507: '新民谣/Neofolk',
  508: '迷幻民谣/Psychedelic Folk',
  509: '前卫民谣/Progressive Folk',
  510: '室内民谣/Chamber Folk',
  511: '先锋民谣/Avant Folk',
  512: '反民谣/Anti Folk',
  513: '凯尔特民谣/Celtic Folk',
  514: '爱尔兰民谣/Irish Folk',
  515: '苏格兰民谣/Scottish Folk',
  516: '中世纪民谣/Medieval Folk',
  517: '中东民谣/Middle Eastern Folk',
  518: '新传统主义民谣/Neo Traditional Folk',
  519: '瑞典民谣/Swedish Folk',
  520: '另类民谣/Alternative Folk',
  521: '爵士民谣/Folk Jazz',
  522: '政治民谣/Political Folk',
  523: '阿巴拉契亚民谣/Appalachian',
  524: '英伦民谣/British Folk',
  525: '民谣复兴/Folk Revival',
  526: '民间歌谣/Folksongs',
  527: '吟游民谣/Minstrel',
  528: '反抗歌曲/Protest Songs',
  529: '水手号子/Sea Shanties',
  530: '传统苏格兰民谣/Traditional Scottish Folk',
  531: '劳动号子/Work Song',

  601: '当代乡村/Contemporary Country',
  602: '乡村流行/Country Pop',
  603: '蓝草/Bluegrass',
  604: '另类乡村/Alt Country',
  605: '乡村摇滚/Country Rock',
  606: '乡村民谣/Country Folk',
  607: '前卫乡村/Progressive Country',
  608: '美式乡村/Americana',
  609: '牛仔/Cowboy',
  610: '传统乡村/Traditional Country',
  611: '传统蓝草/Traditional Bluegrass',
  612: '乡村福音/Country Gospel',
  613: '纳什维尔之声/Nashville Sound',
  614: '当代蓝草/Contemporary Bluegrass',
  615: '乡村布吉/Country Boogie',
  616: '器乐乡村/Instrumental Country',
  617: '新原音/New Acoustic',
  618: '叛道乡村/Outlaw Country',
  619: '前卫蓝草/Progressive Bluegrass',
  620: '弦乐团/String Band',
  621: '都市牛仔/Urban Cowboy',
  622: '西部摇摆/Western Swing',
  623: '新传统主义乡村/Neo Traditionalist Country',
  624: '新传统主义/New Traditionalist',
  625: '赤土/Red Dirt',
  626: '都市乡村/Countrypolitan',
  627: '贝克斯菲尔德小调/Bakersfield Sound',
  628: '小酒馆情歌/Honky Tonk',
  629: '卡车乡村音乐/Truck Driving Country',
  630: '牛仔竞技乡村/Rodeo',
  631: '密集和声/Close Harmony',
  632: '早期乡村/Early Country',
  633: '瓶罐乐队/Jug Band',
  634: '怀旧情怀/Old Timey',
  635: '方块歌舞/Square Dance',
  636: '约德尔/Yodeling',
  637: '西部摇摆乡村/Western Swing Revival',

  701: '当代布鲁斯/Contemporary Blues',
  702: '德克萨斯布鲁斯/Texas Blues',
  703: '电声布鲁斯/Electric Blues',
  704: '电声德克萨斯布鲁斯/Electric Texas Blues',
  705: '东海岸布鲁斯/East Coast Blues',
  706: '非洲布鲁斯/African Blues',
  707: '钢琴布鲁斯/Piano Blues',
  708: '爵士布鲁斯/Jazz Blues',
  709: '灵魂布鲁斯/Soul Blues',
  710: '三角洲布鲁斯/Delta Blues',
  711: '乡村布鲁斯/Country Blues',
  712: '英伦布鲁斯/British Blues',
  713: '原声布鲁斯/Acoustic Blues',
  714: '原声得克萨斯布鲁斯/Acoustic Texas Blues',
  715: '原声芝加哥布鲁斯/Acoustic Chicago Blues',
  716: '芝加哥布鲁斯/Chicago Blues',
  717: '路易斯安那州原生布鲁斯/Acoustic Louisiana Blues',
  718: '孟斐斯原生布鲁斯/Acoustic Memphis Blues',
  719: '新奥尔良原声布鲁斯/Acoustic New Orleans Blues',
  720: '福音布鲁斯/Blues Gospel',
  721: '布鲁斯复兴/Blues Revival',
  722: '经典布鲁斯声乐/Classic Blues Vocals',
  723: '经典女性布鲁斯/Classic Female Blues',
  724: '底特律布鲁斯/Detroit Blues',
  725: '粗口布鲁斯/Dirty Blues',
  726: '早期原声布鲁斯/Early Acoustic Blues',
  727: '早期美国布鲁斯/Early American Blues',
  728: '芝加哥电音布鲁斯/Electric Chicago Blues',
  729: '电音乡村布鲁斯/Electric Country Blues',
  730: '三角洲电音布鲁斯/Electric Delta Blues',
  731: '口琴电音布鲁斯/Electric Harmonica Blues',
  732: '孟菲斯电音布鲁斯/Electric Memphis Blues',
  733: '指弹吉他/Finger Picked Guitar',
  734: '民谣布鲁斯/Folk Blues',
  735: '和声布鲁斯/Harmonica Blues',
  736: '自动点唱机布鲁斯/Juke Joint Blues',
  737: '跳跃布鲁斯/Jump Blues',
  738: '美国路易斯安那州布鲁斯/Louisiana Blues',
  739: '孟菲斯布鲁斯/Memphis Blues',
  740: '现代原声布鲁斯/Modern Acoustic Blues',
  741: '现代布鲁斯/Modern Blues',
  742: '现代三角洲布鲁斯/Modern Delta Blues',
  743: '现代电音布鲁斯/Modern Electric Blues',
  744: '芝加哥现代电音布鲁斯/Modern Electric Chicago Blues',
  745: '新奥尔良布鲁斯/New Orleans Blues',
  746: '纽约布鲁斯/New York Blues',
  747: '皮埃蒙特布鲁斯/Piedmont Blues',
  748: '战前布鲁斯/Pre War Blues',
  749: '战前乡村布鲁斯/Pre War Country Blues',
  750: '战前福音布鲁斯/Pre War Gospel Blues',
  751: '区域布鲁斯/Regional Blues',
  752: '滑音吉他布鲁斯/Slide Guitar Blues',
  753: '歌手布鲁斯/Songster',
  754: '圣路易斯布鲁斯/St. Louis Blues',
  755: '泽地布鲁斯/Swamp Blues',
  756: '传统布鲁斯/Traditional Blues',
  757: '城市布鲁斯/Urban Blues',
  758: '轻歌舞剧布鲁斯/Vaudeville Blues',
  759: '西岸布鲁斯/West Coast Blues',
  760: '劳动号子布鲁斯/Work Songs',

  801: '当代节奏布鲁斯/Contemporary R&B',
  802: '放克/Funk',
  803: '灵魂乐/Soul',
  804: '流行灵魂乐/Pop Soul',
  805: '新灵魂乐/Neo Soul',
  806: '另类节奏布鲁斯/Alternative R&B',
  807: '白人灵魂乐/Blue Eyed Soul',
  808: '芝加哥灵魂乐/Chicago Soul',
  809: '乡村灵魂乐/Country Soul',
  810: '深度放克/Deep Funk',
  811: '深度放克复兴/Deep Funk Revival',
  812: '深度灵魂乐/Deep Soul',
  813: '嘟喔普/Doo Wop',
  814: '走走放克/Go Go',
  815: '孟菲斯灵魂乐/Memphis Soul',
  816: '摩城/Motown',
  817: '新杰克摇摆乐/New Jack Swing',
  818: '新奥尔良节奏布鲁斯/New Orleans R&b',
  819: '北方灵魂乐/Northern Soul',
  820: '费城灵魂乐/Philly Soul',
  821: '迷幻灵魂乐/Psychedelic Soul',
  822: '平静风暴/Quiet Storm',
  823: '柔顺灵魂乐/Smooth Soul',
  824: '南方灵魂乐/Southern Soul',
  825: '合成器放克/Synth Funk',
  826: '都市音乐/Urban',
  827: '当代成人节奏布鲁斯/Adult Contemporary R&B',
  828: '复古灵魂乐/Retro Soul',
  829: '早期节奏布鲁斯/Early R&B',
  830: '纯乐器节奏布鲁斯/R&B Instrumental',
  831: '海滩节奏布鲁斯/Beach',
  832: '褐眼灵魂乐/Brown Eyed Soul',
  833: '市郊灵魂乐/Uptown Soul',

  901: '暗潮/Dark Wave',
  902: '悲核/Sadcore',
  903: '布吉摇滚/Boogie Rock',
  904: '布鲁斯摇滚/Blues Rock',
  905: '车库摇滚/Garage Rock',
  906: '车库摇滚复兴/Garage Rock Revival',
  907: '成人另类/Adult Alternative',
  908: '冲浪摇滚/Surf Rock',
  909: '德国前卫摇滚/Krautrock',
  910: '低保真/Lo Fi',
  911: '电力流行/Power Pop',
  912: '独立摇滚/Indie Rock',
  913: '钢琴摇滚/Piano Rock',
  914: '根源摇滚/Roots Rock',
  915: '工业摇滚/Industrial Rock',
  916: '后垃圾摇滚/Post Grunge',
  917: '后摇/Post Rock',
  918: '后英伦/Post Britpop',
  919: '华丽摇滚/Glam Rock',
  920: '基督摇滚/Christian Rock',
  921: '爵士摇滚/Jazz Rock',
  922: '凯尔特摇滚/Celtic Rock',
  923: '垃圾摇滚/Grunge',
  924: '另类摇滚/Alternative Rock',
  925: '流行摇滚/Pop Rock',
  926: '曼彻斯特音乐/Madchester',
  927: '慢核/Slowcore',
  928: '迷幻摇滚/Psychedelic Rock',
  929: '民谣摇滚/Folk Rock',
  930: '默西节拍/Merseybeat',
  931: '器乐摇滚/Instrumental Rock',
  932: '前卫摇滚/Progressive Rock',
  933: '轻摇滚/Soft Rock',
  934: '日本摇滚/J Rock',
  935: '山区乡村摇滚/Rockabilly',
  936: '实验摇滚/Experimental Rock',
  937: '视觉摇滚/Visual Rock',
  938: '数学摇滚/Math Rock',
  939: '说唱摇滚/Rap Rock',
  940: '酸性摇滚/Acid Rock',
  941: '太空摇滚/Space Rock',
  942: '喜剧摇滚/Comedy Rock',
  943: '仙音/Ethereal Wave',
  944: '先锋前卫摇滚/Avant Prog',
  945: '新浪漫/New Romantic',
  946: '新迷幻/Neo Psychedelia',
  947: '学院摇滚/College Rock',
  948: '艺术摇滚/Art Rock',
  949: '英伦摇滚/Britpop',
  950: '硬摇滚/Hard Rock',
  951: '原声摇滚/Acoustic Rock',
  952: '噪音摇滚/Noise Rock',
  953: '沼泽摇滚/Swamp Pop',
  954: '自赏/Shoegazing',
  955: '澳大利亚摇滚/Aboriginal Rock',
  956: '专辑摇滚/Album Rock',
  957: '美国传统摇滚乐/American Trad Rock',
  958: '舞台摇滚/Arena Rock',
  959: '澳洲摇滚/Aussie Rock',
  960: '酒吧乐队/Bar Band',
  961: '英伦民谣摇滚/British Folk Rock',
  962: '坎特伯雷场景/Canterbury Scene',
  963: '底特律摇滚/Detroit Rock',
  964: '兄弟会摇滚/Frat Rock',
  965: '法系摇滚/French Rock',
  966: '中心地区摇滚/Heartland Rock',
  967: '改造小车/Hot Rod',
  968: '改造小车复兴/Hot Rod Revival',
  969: '詹姆斯邦/Jam Bands',
  970: '韩国摇滚/Korean Rock',
  971: '德国电气摇滚/Kraut Rock',
  972: '拉丁摇滚/Latin Rock',
  973: '艺术前卫摇滚/Prog Rock',
  974: '酒吧摇滚/Pub Rock',
  975: '重新派摇滚/Retro Rock',
  976: '西班牙语摇滚/Rock en Español',
  977: '山地复兴/Rockabilly Revival',
  978: '南方摇滚/Southern Rock',
  979: '冲浪复兴/Surf Revival',
  980: '前卫另类摇滚/Progressive Alternative Rock',
  981: '电子摇滚/Electronic Rock',
  982: '新浪潮/New Wave',
  983: '朋克/Punk',

  1001: '自然新世纪/Nature New Age',
  1002: '精神新世纪/Spiritual New Age',
  1003: '民族融合新世纪/Ethnic Fusion New Age',
  1004: '宗教新世纪/Religionary New Age',
  1005: '太空新世纪/Space New Age',
  1006: '放松新世纪/Relaxation New Age',
  1007: '凯尔特新世纪/Celtic New Age',
  1008: '日本新世纪/Japanese N',
  1009: '当代乐器/Contemporary Instrumental',
  1010: '自然环境/Environmental',
  1011: '排箫 /新世纪/Flute/New Age',
  1012: '吉他 /新世纪/Guitar/New Age',
  1013: '竖琴 /新世纪/Harp/New Age',
  1014: '治愈新世纪/Healing',
  1015: '键盘 /合成器 /新世纪/Keyboard/Synthesizer/New Age',
  1016: '冥想 /放松/Meditation/Relaxation',
  1017: '神秘极简主义/Mystical Minimalism',
  1018: '新传统/Neo Classical',
  1019: '新世纪音调诗/New Age Tone Poems',
  1020: '自助和发展/Self Help & Development',
  1021: '乐器独奏/Solo Instrumental',
  1022: '泰克诺部落/Techno Tribal',

  1101: '重金属/Heavy Metal',
  1102: '激流金属/Thrash Metal',
  1103: '另类金属/Alternative Metal',
  1104: '死亡金属/Death Metal',
  1105: '前卫金属/Progressive Metal',
  1106: '石人金属/Stoner Metal',
  1107: '黑金属/Black Metal',
  1108: '民谣金属/Folk Metal',
  1109: '说唱金属/Rap Metal',
  1110: '厄运金属/Doom Metal',
  1111: '新金属/Nu Metal',
  1112: '放克金属/Funk Metal',
  1113: '氛围黑金属/Atmospheric Black Metal',
  1114: '氛围泥浆金属/Atmospheric Sludge Metal',
  1115: '先锋金属/Avant Garde Metal',
  1116: '自赏黑/Blackgaze',
  1117: '残忍死亡金属/Brutal Death Metal',
  1118: '凯尔特金属/Celtic Metal',
  1119: '基督金属/Christian Metal',
  1120: '科幻金属/Cyber Metal',
  1121: '电子碾/Cybergrind',
  1122: '死亡厄运金属/Death Doom Metal',
  1123: "死亡摇滚/Death n'Roll",
  1124: '死核/Deathcore',
  1125: '死碾/Deathgrind',
  1126: '自杀黑金属/Depressive Black Metal',
  1127: '数学金属/Djent / Math Metal',
  1128: '蜂鸣金属/Drone Metal',
  1129: '葬礼厄运金属/Funeral Doom Metal',
  1130: '华丽金属/Glam Metal',
  1131: '血碾/Goregrind',
  1132: '哥特金属/Gothic Metal',
  1133: '碾核/Grindcore',
  1134: '律动金属/Groove Metal',
  1135: '工业金属/Industrial Metal',
  1136: '中世纪民谣金属/Medieval Folk Metal',
  1137: '旋律黑金/Melodic Black Metal',
  1138: '旋律死亡金属/Melodic Death Metal',
  1139: '英伦金属新浪潮/NWOBHM / New Wave Of British Heavy Metal',
  1140: '新古典金属/Neo Classical Metal',
  1141: '能量金属/Power Metal',
  1142: '朋克金属/Punk Metal',
  1143: '泥浆金属/Sludge Metal',
  1144: '速度金属/Speed Metal',
  1145: '交响金属/Symphonic Metal',
  1146: '技术死亡金属/Technical Death Metal',
  1147: '维京金属/Viking Metal',
  1148: '英伦金属/British Metal',
  1149: '吉他演奏家/Guitar Virtuoso',
  1150: '英伦重金属新浪潮/New Wave of British Heavy Metal',
  1151: '流行金属/Pop Metal',
  1152: '后金属/Post Metal',
  1153: '斯堪的纳维亚金属/Scandinavian Metal',
  1154: '黑色交响/Symphonic Black Metal',

  1201: '回响/Dub',
  1202: '斯卡/Ska',
  1203: '雷鬼流行/Reggae Pop',
  1204: '雷嘎/Ragga',
  1205: '舞厅/Dancehall',
  1206: '根源雷鬼/Roots Reggae',
  1207: '迪杰/Deejay / Toasting',
  1208: '当代雷鬼/Contemporary Reggae',
  1209: '雷击顿/Reggaeton',
  1210: '洛克斯代迪/Rocksteady',
  1211: '蓝调节拍/Bluebeat',
  1212: '加勒比传统/Caribbean Traditions',
  1213: '强节拍诗歌/Dub Poetry',
  1214: '情人摇滚爵士/Lovers Rock',
  1215: '政治雷鬼/Political Reggae',
  1216: '柔顺爵士雷鬼/Smooth Reggae',

  1301: '柏林学派/Berlin School',
  1302: '病态氛围/Illbient',
  1303: '部族浩室舞曲/Tribal House',
  1304: '弛放/Chillout',
  1305: '出神舞曲/Trance',
  1306: '大节拍/Big Beat',
  1307: '迪斯科/Disco',
  1308: '底特律科技舞曲/Detroit Techno',
  1309: '电工业舞曲/Electro Industrial',
  1310: '电科技舞曲/Electro Techno',
  1311: '电气浩室/Electro House',
  1312: '电子迪斯科/Electro Disco',
  1313: '电子行为舞曲/EBM',
  1314: '欧洲迪斯科/Euro Disco',
  1315: '伊泰洛迪斯科/Italo Disco',
  1316: '电子乐/Electronica',
  1317: '电子民谣/Folktronica',
  1318: '独立电子乐/Indietronica',
  1319: '两步车库/2 Step',
  1320: '放克打击乐/Funky Breaks',
  1321: '放克电子/Electro (Electro Funk)',
  1322: '氛围浩室舞曲/Ambient House',
  1323: '氛围回响/Ambient Dub',
  1324: '氛围科技舞曲/Ambient Techno',
  1325: '氛围音乐/Ambient',
  1326: '复合电气/Complextro',
  1327: '高能量迪斯科/Hi NRG',
  1328: '工业科技舞曲/Industrial Techno',
  1329: '工业舞曲/Industrial Dance',
  1330: '工业音乐/Industrial music',
  1331: '鼓打贝斯/Drum & Bass',
  1332: '果阿迷幻舞曲/Goa Trance',
  1333: '寒潮/Chillwave',
  1334: '浩室舞曲/House',
  1335: '合成器潮/Synthwave',
  1336: '合成器流行/Synthpop',
  1337: '黑暗氛围/Dark Ambient',
  1338: '后迪斯科/Post Disco',
  1339: '后回响贝斯/Post Dubstep',
  1340: '后回响重拍/Brostep',
  1341: '缓拍/Downtempo',
  1342: '恍惚嘻哈舞曲/Wonky',
  1343: '回响贝斯/Dubstep',
  1344: '回响科技舞曲/Dub Techno',
  1345: '极端科技舞曲/Gabber',
  1346: '极简潮/Minimal Wave',
  1347: '极简合成器/Minimal Synth',
  1348: '极简科技舞曲/Minimal Techno',
  1349: '即兴舞曲/Freestyle',
  1350: '科技浩室/Tech House',
  1351: '科技舞曲/Techno',
  1352: '快乐硬核/Happy Hardcore',
  1353: '另类舞曲/Alternative Dance',
  1354: '脉冲/Glitch',
  1355: '脉冲流行/Glitch Hop',
  1356: '蒙巴顿舞曲/Moombahton',
  1357: '迷幻氛围/Psybient',
  1358: '迷幻科技舞曲/Acid Techno',
  1359: '能量电子/Power Electronics',
  1360: '女巫浩室/Witch House',
  1361: '欧陆舞曲/Euro Dance',
  1362: '泡泡糖贝斯/Bubblegum Bass',
  1363: '前卫电子/Progressive Electronic',
  1364: '前卫浩室/Progressive House',
  1365: '前卫迷幻舞曲/Progressive Trance',
  1366: '热带浩室/Tropical House',
  1367: '锐舞音乐/Rave Music',
  1368: '深浩室舞曲/Deep House',
  1369: '神游舞曲/Trip Hop',
  1370: '酸性浩室舞曲/Acid House',
  1371: '碎拍/Breakbeat',
  1372: '微浩室舞曲/Microhouse',
  1373: '微声/Microsound',
  1374: '未来贝斯/Future Bass',
  1375: '未来车库舞曲/Future Garage',
  1376: '未来浩室/Future House',
  1377: '污垢舞曲/Grime',
  1378: '陷阱舞曲/Trap',
  1379: '芯片音乐/Chiptune',
  1380: '新迪斯科/Nu Disco',
  1381: '新拍/New Beat',
  1382: '旋律回响贝斯/Melodic Dubstep',
  1383: '英国贝斯舞曲/UK Bass',
  1384: '英国车库舞曲/UK Garage',
  1385: '英国放克舞曲/UK Funky',
  1386: '硬核科技舞曲/Hardcore Techno',
  1387: '硬派舞曲/Hardstyle',
  1388: '炸房浩室/Big Room House',
  1389: '蒸汽波/Vaporwave',
  1390: '芝加哥浩室舞曲/Chicago House',
  1391: '智能舞曲/IDM',
  1392: "钻击贝斯/Drill 'n' Bass",
  1393: '环境打击乐/Ambient Breakbeat',
  1394: '放克舞/Baile Funk',
  1395: '碎核/Breakcore',
  1396: '俱乐部爵士/Clubjazz',
  1397: '重拍/Downbeat',
  1398: '电子原声 /Electro Acoustic',
  1399: '电子爵士/Electro Jazz',

  1400: '试验环境气氛乐/Experimental Ambient',
  1401: '试验回响贝斯/Experimental Dub',
  1402: '试验电子乐/Experimental Electro',
  1403: '试验舞曲/Experimental Jungle',
  1404: '试验科技舞曲/Experimental Techno',
  1405: '法系浩室/French House',
  1406: '车库音乐/Garage',
  1407: "工业钻击贝斯/Industrial Drum'n'Bass",
  1408: '爵士浩室/Jazz House',
  1409: '乱步街区/Juke / Footwork',
  1410: '实验性浩室/Left Field House',
  1411: '新电子/Neo Electro',
  1412: '新碎拍/Nu Breaks',
  1413: '迷幻出神舞曲/Psytrance',
  1414: '狂欢舞曲/Rave',
  1415: '出神贝斯舞曲/Techno Bass',
  1416: '出神回响贝斯/Techno Dub',
  1417: '西方古典/Western Classical Music',
  1418: '浪漫主义/Romanticism',
  1419: '古典主义/Classical period',
  1420: '巴洛克音乐/Baroque Music',
  1421: '现代古典/Modern Classical',
  1422: '声乐/Vocal Music',
  1423: '管弦乐/Orchestral',
  1424: '歌剧/Opera',
  1425: '教堂音乐/Church Music',
  1426: '艺术歌曲/Lied',
  1427: '合唱团/Choral',
  1428: '交响乐/Symphonic Music',
  1429: '交响曲/Symphony',
  1430: '协奏曲/Concerto',
  1431: '芭蕾/Ballet',
  1432: '独奏/Recital',
  1433: '室内乐/Chamber Music',
  1434: '古典跨界/Classical Crossover',
  1435: '康塔塔/Cantata',
  1436: '键盘音乐/Keyboard',
  1437: '极简主义/Minimalism',
  1438: '清唱剧/Oratorio',
  1439: '后极简主义/Post Minimalism',
  1440: '奏鸣曲/Sonata',

  1501: '沙发音乐/Lounge',
  1502: '异域/Exotica',
  1503: '太空时代流行/Space Age Pop',
  1504: '器乐流行/Instrumental Pop',
  1505: '轻音乐流行/Light Pop',
  1506: '管弦乐流行/Orchestral Pop',
  1507: '器乐独奏/Solo Instrumen',
  1508: '轻流行/Easy Pop',
  1509: '吉他 / 轻音乐/Guitar / Easy Listening',
  1510: '气氛音乐/Mood Music',
  1511: '管弦乐 / 轻音乐/Orchestral / Easy Listening',
  1512: '管风琴 / 轻音乐/Organ / Easy Listening',
  1513: '排箫 / 轻音乐/Panflute / Easy Listening',
  1514: '钢琴 / 轻音乐/Piano / Easy Listening',
  1515: '小号 / 轻音乐/Trumpet / Easy Listening',
  1516: '华尔兹/Waltz',

  1602: '童谣/Nursery Rhymes',
  1603: '童声合唱团/Children\'s Chorus',
  1604: '胎教音乐/Prenatal music',
  1605: "儿童民谣/Children's Folk",
  1606: "儿童流行/Children's Pop",
  1607: "儿童摇滚/Children's Rock",
  1608: "儿童原创/Children's Songwriters",
  1609: '教育/Educational',
  1610: '童话故事/Fairy Tales',
  1611: '摇篮曲/Lullabies',
  1612: '跟唱/Sing Alongs',

  1703: '红歌/Red Song',
  1705: '戏曲/Chinese Opera',
  1707: '中国民族歌曲/Chinese Traditional Folk Song',
  1708: '中国民族器乐/Chinese Folk Music',
  1709: '藏族音乐/Tibetan Native Music',
  1710: '广场舞/Public Sqaure Dancing',
  1711: '新民歌/New Chinese Traditional Folk Song',
  1712: '民族风/National Style',
  1713: '军旅歌曲/Military Songs',

  1801: '韩国| 演歌/Korea Trot',
  1802: '韩国传统音乐/Korean Traditional Music',
  1803: '日本| 岛呗/Shima Uta',
  1804: '日本| 演歌/Enka',
  1805: '日本| 邦乐/Japanese Traditional Music',
  1806: '非洲打击乐/Afrobeat',
  1807: '印度| 邦拉/Bhangra',
  1808: '美国| 凯金/Cajun',
  1809: '加勒比| 卡吕普索/Calypso',
  1810: '法国| 香颂/Chanson',
  1811: '葡萄牙| 法朵/Fado',
  1812: '西班牙| 弗拉门戈/Flamenco',
  1813: '格里高利圣咏/Gregorian chant',
  1814: '犹太音乐/Jewish Music',
  1815: '犹太| 克莱兹梅尔/Klezmer',
  1816: '巴西| 全域音乐/MPB',
  1817: '多米尼加| 默朗格/Merengue',
  1818: '巴基斯坦| 卡瓦里/Qawwali',
  1819: '印度| 拉格/Raga',
  1820: '古巴| 伦巴/Rumba',
  1821: '巴西| 桑巴/Samba',
  1822: '古巴| 颂乐/Son',
  1823: '蒙古| 呼麦/Throat Singing',
  1824: '世界融合/World Fusion',
  1825: '世界节拍/Worldbeat',
  1826: '美国| 柴迪科舞曲/Zydec',
  1827: '亚洲/Asia',
  1828: '澳大利亚/Australia',
  1829: '加勒比海地区/Caribbean',
  1830: '当代凯尔特/Contemporary Celtic',
  1831: '印尼古调/Dangdut',
  1832: '饮酒歌/Drinking Songs',
  1833: '欧洲/Europe',
  1834: '波斯音乐/Farsi',
  1835: '法国/France',
  1836: '夏威夷/Hawaii',
  1837: '伊比利亚音乐/Iberia',
  1838: '印尼宗教曲目/Indonesian Religious',
  1839: '以色列音乐/Israeli',
  1840: '日本/Japan',
  1841: '北美洲/North America',
  1842: 'Polka/Polka',
  1843: '索卡/Soca',
  1844: '南非/South Africa',
  1845: '南美洲/South America',
  1846: '探戈舞曲/Tango',
  1847: '传统凯尔特/Traditional Celtic',
  1848: '柴迪科舞曲/Zydeco',
  1849: '提克斯密克斯/Tex Mex',

  // 1901: '原声配乐/Soundtrack',
  // 1902: '电影原声/Film Score',
  // 1903: '电视原声/Television Music',
  // 1904: '卡通配乐/Cartoon Music',
  // 1905: '游戏配乐/Video Game Music',
  // 1906: '宝莱坞电影配乐/Filmi',
  // 1907: '日本动漫游戏/Japanese ACG',

  2001: '自由即兴/Free Improvisation',
  2002: '噪音/Noise',
  2003: '自然采样/Field Recordings',
  2004: '声效拼贴/Sound Collage',
  2005: '蜂鸣/Drone',
  2006: '实验电子/Experimental Electronic',

  2101: '有声书/Audio Book',
  2102: '广播剧/Radio Drama',

  2301: '国风电子/Chinoiserie Electronic Music',

  2701: '圣诞歌曲/Christmas Music',
})

export const hasSubGenreSet = new Set(
  Object.keys(subGenreMap)
    .map(item => +item.slice(0, -2))
)

export const authTypeMap = {
  1: '录音版权',
  2: '词版权',
  3: '曲版权'
}
